import { z } from 'zod'
import type { TwoFactorBackupCodes } from '../../models/TwoFactorBackupCodes'
import { backupCodesFromPlainCodes } from '../../models/TwoFactorBackupCodes'

export const TwoFactorBackupCodesDTO = z.object({
  backup_codes: z.array(z.string()).min(1)
})

export type TwoFactorBackupCodesDTO = z.infer<typeof TwoFactorBackupCodesDTO>

export function mapDTOToTwoFactorBackupCodes (dto: TwoFactorBackupCodesDTO): TwoFactorBackupCodes {
  return backupCodesFromPlainCodes(dto.backup_codes)
}

export function mapTwoFactorBackupCodesToDTO (model: TwoFactorBackupCodes): TwoFactorBackupCodesDTO {
  return {
    backup_codes: model.items.map(item => item.code)
  }
}
